import React from "react";
import { Formik, Field, Form, FieldArray } from "formik";
import {
  TextField,
  Loading,
  MultiSelect,
  Select,
  PersianDataPicker,
} from "components/form";
import { required, validationWrapper, isUserName } from "lib/formValidations";
import {
  transformTranslateFromValues,
  transformTranslateServerValues,
  dateTimeToserver,
} from "lib/helpers";
import Modal from "components/Modal";
import { useCore } from "store/core";
import { TextArea } from "components/form";
import cleanObject from "utils/editHelper";
import { GalleryField } from "components/form";
import MultySearchSelect from "utils/MultySearchSelect";
import initItem from "utils/initItem";
import extractValues from "utils/extractValues";
import MetaDataComponent from "utils/MetaDataComponent";
import TextFieldSlug from "components/form/TextFieldSlug";
import SearchSelect from "utils/SearchSelect";
import { cleanArray } from "utils/editHelper";
// components

export default function Edit(props) {
  const core = useCore();
  const { show, item } = props;

  const config = {
    "table.team": {
      valueField: "id",
      labelFields: ["translations.fa.name"],
    },
  };
  const updatedItem = initItem(item, config);

  return (
    <>
      <Modal show={props.show} handleClose={props.close} title={props.title}>
        <Formik
          initialValues={updatedItem}
          onSubmit={async (values, { setSubmitting }) => {
            if (values.birthday)
              values.birthday = dateTimeToserver(values.birthday, "YYYY-MM-DD");

            const clean = cleanObject(values, [
              "id",
              "uuid",
              "updatedAt",
              "createdAt",
              "createdBy",
            ]);

            const table = cleanArray(values.table, [
              "id",
              "updatedAt",
              "createdAt",
            ]);
            clean.table = table;

            const result = extractValues(clean, ["table.team"]);

            await props.submit(result, item.id);
            props.close();
            setSubmitting(false);
          }}
          enableReinitialize
        >
          {({ isSubmitting, dirty, values, setFieldValue }) => (
            <Form>
              <div className="modal-body gap-y-3">
                <div className="intro-x grid md:grid-cols-2 md:gap-3">
                  <Field
                    placeholder="نام"
                    label="نام :"
                    name="translations.fa.name"
                    component={TextField}
                  />
                  <Field
                    placeholder="نام(en)"
                    label="نام (en):"
                    name="translations.en.name"
                    component={TextField}
                  />
                  <Field
                    placeholder="ترتیب"
                    label="ترتیب"
                    name="order"
                    component="input"
                    type="number"
                    className="w-full px-3 py-2 border rounded"
                  />
                </div>
                <div className="w-full flex justify-between">
                  <div className="w-full">
                    <Field
                      label="لوگو"
                      name="logo"
                      dataType="id"
                      component={GalleryField}
                    />
                  </div>
                </div>

                <div className="mt-10">
                  <FieldArray name="table">
                    {({ push, remove }) => (
                      <div className="border p-4 rounded">
                        <div className="flex items-center justify-between mb-6">
                          <h3 className="font-bold mb-4 text-lg">جدول لیگ</h3>
                          <button
                            type="button"
                            onClick={() =>
                              push({
                                team: "",
                                matchNumber: "",
                                winneNumber: "",
                                equalNumber: "",
                                lostNumber: "",
                                goalNumber: "",
                                floweredNumber: "",
                                order: "",
                                scoreNumber: "",
                              })
                            }
                            className="mb-6 px-4 py-2 bg-blue-500 text-white rounded shadow hover:bg-blue-600"
                          >
                            افزودن نتیجه
                          </button>
                        </div>
                        {values?.table?.map((event, index) => (
                          <div key={index} className="border-b pb-6 mb-6">
                            <div className="mb-4">
                              <Field
                                name={`table[${index}].team`}
                                label="تیم:"
                                component={SearchSelect}
                                searchFields="translations.name"
                                collectionName="teamNew"
                                showFields="translations.name"
                                placeholder="انتخاب تیم"
                                className="w-full px-3 py-2 border rounded shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
                              />
                            </div>

                            <div className="mb-4">
                              <label className="block text-gray-700 text-sm font-bold mb-2">
                                تعداد بازی:
                              </label>
                              <Field
                                name={`table[${index}].matchNumber`}
                                type="number"
                                placeholder=" تعداد بازی"
                                className="w-full px-3 py-2 border rounded shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
                              />
                            </div>

                            <div className="mb-4">
                              <label className="block text-gray-700 text-sm font-bold mb-2">
                                تعداد برد:
                              </label>
                              <Field
                                name={`table[${index}].winneNumber`}
                                type="number"
                                placeholder=" تعداد برد"
                                className="w-full px-3 py-2 border rounded shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
                              />
                            </div>

                            <div className="mb-4">
                              <label className="block text-gray-700 text-sm font-bold mb-2">
                                تعداد مساوی:
                              </label>
                              <Field
                                name={`table[${index}].equalNumber`}
                                type="number"
                                placeholder=" تعداد مساوی"
                                className="w-full px-3 py-2 border rounded shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
                              />
                            </div>

                            <div className="mb-4">
                              <label className="block text-gray-700 text-sm font-bold mb-2">
                                تعداد باخت:
                              </label>
                              <Field
                                name={`table[${index}].lostNumber`}
                                type="number"
                                placeholder=" تعداد باخت"
                                className="w-full px-3 py-2 border rounded shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
                              />
                            </div>

                            <div className="mb-4">
                              <label className="block text-gray-700 text-sm font-bold mb-2">
                                تعداد گل زده شده:
                              </label>
                              <Field
                                name={`table[${index}].goalNumber`}
                                type="number"
                                placeholder=" تعداد گل زده شده"
                                className="w-full px-3 py-2 border rounded shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
                              />
                            </div>

                            <div className="mb-4">
                              <label className="block text-gray-700 text-sm font-bold mb-2">
                                تعداد گل خورده:
                              </label>
                              <Field
                                name={`table[${index}].floweredNumber`}
                                type="number"
                                placeholder=" تعداد گل خورده"
                                className="w-full px-3 py-2 border rounded shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
                              />
                            </div>

                            <div className="mb-4">
                              <label className="block text-gray-700 text-sm font-bold mb-2">
                                ترتیب:
                              </label>
                              <Field
                                name={`table[${index}].order`}
                                type="number"
                                placeholder="ترتیب"
                                className="w-full px-3 py-2 border rounded shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
                              />
                            </div>

                            <div className="mb-4">
                              <label className="block text-gray-700 text-sm font-bold mb-2">
                                امیتاز:
                              </label>
                              <Field
                                name={`table[${index}].scoreNumber`}
                                type="number"
                                placeholder="امیتاز"
                                className="w-full px-3 py-2 border rounded shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
                              />
                            </div>

                            <button
                              type="button"
                              onClick={() => remove(index)}
                              className="px-4 py-2 bg-red-500 text-white rounded shadow hover:bg-red-600"
                            >
                              حذف نتیجه
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                  </FieldArray>
                </div>
              </div>

              <div className="modal-footer text-right">
                <button
                  className="btn btn-primary w-20"
                  type="submit"
                  disabled={!!(isSubmitting || !dirty)}
                >
                  {" "}
                  {isSubmitting ? <Loading /> : "ذخیره"}
                </button>
                <button
                  type="button"
                  disabled={isSubmitting}
                  onClick={props.close}
                  className="btn btn-outline-secondary w-20 mr-1"
                >
                  انصراف
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
}
